module.exports = __webpack_public_path__ + "static/hero-photo-03-3edcb3709fe11ab8d9c11352164e11e8.png";